import axios from 'axios';
import { constants } from '../common/constants/constants';
import { axiosInstance, useAxios } from './axiosService';
import { endImpersonation } from './impersonationSession';

// the handoff exchange runs before the tab has a session: no interceptors, no Authorization header
const bareAxios = axios.create({ baseURL: constants.API_BASE_URL });

export const exchangeHandoffCode = async code => {
    const { data } = await bareAxios.post('/impersonation/exchange', { code });
    return data;
};

/** Ends the session on the server (best effort) and then in this tab. */
export const stopImpersonation = async () => {
    try {
        await axiosInstance.post('/impersonation/current/stop');
    } catch (error) {
        // the session may already be over; the tab ends either way
    } finally {
        endImpersonation('stopped');
    }
};

export const switchImpersonatedTeam = async teamId => {
    const { data } = await axiosInstance.post('/impersonation/current/team', { teamId });
    return data;
};

export const useImpersonationService = () => {
    const { axios: instance } = useAxios();

    // the admin-side calls handle their own errors where they are made, never through the global error page:
    // the config is asked from every page (the menu entry), and a refusal there must not navigate anywhere
    const own = { skipGlobalErrorHandler: true };
    const getConfig = async () => (await instance.get('/impersonation/config', own)).data;
    const searchUsers = async body => (await instance.post('/impersonation/users/search', body, own)).data;
    const startSession = async body => (await instance.post('/impersonation/sessions', body, own)).data;
    const getSessions = async params => (await instance.get('/impersonation/sessions', { params, ...own })).data;
    const getSessionEvents = async id => (await instance.get(`/impersonation/sessions/${id}/events`, own)).data;
    const revokeSession = async id => (await instance.post(`/impersonation/sessions/${id}/revoke`, null, own)).data;
    const revokeAllSessions = async () => (await instance.post('/impersonation/sessions/revoke-all', null, own)).data;

    return { getConfig, searchUsers, startSession, getSessions, getSessionEvents, revokeSession, revokeAllSessions };
};
